import React, { Component } from 'react';
import { connect } from 'react-redux';

import AssetsForm from 'components/assets/form_sections';
import { acceptHistoric, rejectHistoric, getAsset } from 'containers/assets/actions';
import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';
import { getLocations } from 'selectors/lists';
import { getHistoricsIsSaving } from 'selectors/assets';
import { addGrowlSuccess, addGrowlError } from 'messages/actions';

class AssetEditHistoricRow extends Component {
  state = { collapsed: true };

  handleAccept = (record) => {
    this.props
      .accept(record.id, record._asset._id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .then(() =>
        this.props.getAsset(record._asset._id, this.props.company.id, this.props.subcompany.id)
      )
      .catch((e) => this.props.error(e.message));
  };
  handleReject = (record) => {
    this.props
      .reject(record.id, record._asset._id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .then(() =>
        this.props.getAsset(record._asset._id, this.props.company.id, this.props.subcompany.id)
      )
      .catch((e) => this.props.error(e.message));
  };
  handleToggleCollapsed = () => this.setState({ collapsed: !this.state.collapsed });

  render = () => (
    <AssetsForm.HistoricsRow
      isSaving={this.props.isSaving}
      record={this.props.record}
      locations={this.props.locations}
      collapsed={this.state.collapsed}
      handleToggleCollapsed={this.handleToggleCollapsed}
      handleAccept={this.handleAccept}
      handleReject={this.handleReject}
    />
  );
}

const mapStateToProps = (state) => ({
  isSaving: getHistoricsIsSaving(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
  permissions: getPermissions(state),
  locations: getLocations(state),
});
const mapDispatchToProps = {
  getAsset: getAsset,
  accept: acceptHistoric,
  reject: rejectHistoric,
  success: addGrowlSuccess,
  error: addGrowlError,
};

export default connect(mapStateToProps, mapDispatchToProps)(AssetEditHistoricRow);



// WEBPACK FOOTER //
// src/containers/assets/edit_sections/AssetEditHistoricRow.js